import { useMemo } from "react";

import { Mandate } from "checkout-experience/components/mandate/mandate";
import {
  MandateConfig,
  PaymentType,
} from "checkout-query-client/types/form-types";

import { mandateWrapperClass, marginTopClass } from "./manadate-list.css";

export type Placement = "paymentMethod" | "placeOrder";

type MandateListProps = {
  paymentType?: PaymentType;
  mandates: Array<MandateConfig>;
  placement: Placement;
};

export const MandateList = (props: MandateListProps) => {
  const { paymentType, mandates, placement } = props;
  const mandateType = placement === "placeOrder" ? "placeOrder" : paymentType;

  const enabledMandates = useMemo(
    () => mandates.filter((mandate) => mandate.enabled),
    [mandateType, mandates]
  );

  return (
    <>
      {enabledMandates.length >= 1 ? (
        <div
          className={`${mandateWrapperClass} ${placement !== "placeOrder" ? marginTopClass : ""}`}
        >
          {enabledMandates?.map((mandate, index) => (
            <Mandate
              key={mandate.mandateId}
              mandate={mandate}
              mandateType={mandateType!}
              index={index + 1}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};
